import { getToken, returnError } from './helperFunc';
import {
	registerOperatorAction,
	verifyOperatorAction,
	loginOperatorAction,
	createRMAction,
	createRazerAction,
	checkSessionAction,
	loyaltyAdminCheckAction,
	fetchRMAction,
	fetchTokenkeyAction,
	tokenkeyAction,
	loginDistributorAction,
	fetchOperatorsAction,
	loginStaffAction,
	resetPasswordAction,
	sendResetEmailAction,
	createDuitnowAction,
	fetchDuitnowAction,
	fetchTokenkeyDuitnowAction,
	tokenkeyDuitnowAction,
	fetchTokenkeyRazerAction,
	tokenkeyRazerAction,
	fetchRazerAction,
	updateRMAction,
	updateRazerAction,
	updateDuitnowAction,
	verifyDistributorAction,
	verifyOtpOperatorAction,
	verifyStaffAction,
	fetch2faAction,
	verifyUser2faAction,
	createAmpersandPayAction,
	fetchAmpersandPayAction,
	updateAmpersandPayAction,
	createGhlAction,
	fetchTokenkeyGhlAction,
	tokenkeyGhlAction,
	fetchGhlAction,
	updateGhlAction,
	createScan2PayAction,
	updateScan2PayAction,
	fetchScan2PayAction,
	fetchTokenkeyScan2PayAction,
	tokenkeyScan2PayAction,
	fetchTokenkeyKipleAction,
	tokenkeyKipleAction,
	createKipleAction,
	updateKipleAction,
	fetchKipleAction,
	fetchTokenkeyHitpayAction,
	tokenkeyHitpayAction,
	createHitpayAction,
	updateHitpayAction,
	fetchHitpayAction,
	fetchTokenkeyPagbankAction,
	tokenkeyPagbankAction,
	createPagbankAction,
	updatePagbankAction,
	fetchPagbankAction,
	fetchTokenkey2c2pAction,
	tokenkey2c2pAction,
	create2c2pAction,
	update2c2pAction,
	fetch2c2pAction,
	fetchTokenkeyRhbAction,
	tokenkeyRhbAction,
	createRhbAction,
	updateRhbAction,
	fetchRhbAction,
	fetchTokenkeyCybersourceAction,
	tokenkeyCybersourceAction,
	createCreditcardAction,
	updateCreditcardAction,
	fetchCreditcardAction,
    checkoutInvoicesAction,
    checkoutWithoutCardAction,
	createCybersourceAction,
	updateCybersourceAction,
	fetchCybersourceAction,
	fetchTokenkeyBangkokBankPromptPayAction,
	tokenkeyBangkokBankPromptPayAction,
	createBangkokBankPromptPayAction,
	updateBangkokBankPromptPayAction,
	fetchBangkokBankPromptPayAction,
	fetchTokenkeyBangkokBankDeeplinkAction,
	tokenkeyBangkokBankDeeplinkAction,
	createBangkokBankDeeplinkAction,
	updateBangkokBankDeeplinkAction,
	fetchBangkokBankDeeplinkAction,
	fetchTokenkeyPaywayAction,
	tokenkeyPaywayAction,
	createPaywayAction,
	updatePaywayAction,
	fetchPaywayAction,
	createRazerOpaAction,
	updateRazerOpaAction,
	fetchRazerOpaAction,
	createCompanyAction,
	fetchCompanyAction,
	sendChangeEmailLinkAction,
	verifyChangeEmailLinkAction,
	saveUserPreferenceAction,
	fetchUserPreferenceAction,
	getResolveConfigAction,
	updateResolveConfigAction,
	getNotificationCredentialAction,
	getDistributorUserCredentialAction,
	getClientUserCredentialAction,
	loginClientAction,
	addNotificationCredentialAction,
	getNotificationTemplatesAction,
	blastEmailAction,
	blastSmsAction,
	topupCheckoutAction,
	fetchContactAction ,
	unconfigureNotificationCredentialAction
} from './requestEndpoints';

const SET_USER_LOADING = 'SET_USER_LOADING';
const CLEAR_USER_ERROR = 'CLEAR_USER_ERROR';

const STAFF_LOGIN_SUCCESS = 'STAFF_LOGIN_SUCCESS';
const STAFF_LOGIN_FAIL = 'STAFF_LOGIN_FAIL';

const OPERATOR_LOGIN_SUCCESS = 'OPERATOR_LOGIN_SUCCESS';
const OPERATOR_LOGIN_FAIL = 'OPERATOR_LOGIN_FAIL';

const DISTRIBUTOR_LOGIN_SUCCESS = 'DISTRIBUTOR_LOGIN_SUCCESS';
const DISTRIBUTOR_LOGIN_FAIL = 'DISTRIBUTOR_LOGIN_FAIL';
const CLIENT_LOGIN_SUCCESS = 'CLIENT_LOGIN_SUCCESS';
const CLIENT_LOGIN_FAIL = 'CLIENT_LOGIN_FAIL';

const USER_DETAILS_SUCCESS = 'USER_DETAILS_SUCCESS';
const USER_DETAILS_FAIL = 'USER_DETAILS_FAIL';

const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS';
const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL';

const USER_VERIFY_SUCCESS = 'USER_VERIFY_SUCCESS';
const USER_VERIFY_FAIL = 'USER_VERIFY_FAIL';

const CREATE_RM_SUCCESS = 'CREATE_RM_SUCCESS';
const CREATE_RM_FAIL = 'CREATE_RM_FAIL';

const CREATE_RAZER_SUCCESS = 'CREATE_RAZER_SUCCESS';
const CREATE_RAZER_FAIL = 'CREATE_RAZER_FAIL';

const FETCH_RM_SUCCESS = 'FETCH_RM_SUCCESS';
const FETCH_RM_FAIL = 'FETCH_RM_FAIL';

const FETCH_RAZER_SUCCESS = 'FETCH_RAZER_SUCCESS';
const FETCH_RAZER_FAIL = 'FETCH_RAZER_FAIL';

const FETCH_TOKENKEY_SUCCESS = 'FETCH_TOKENKEY_SUCCESS';
const FETCH_TOKENKEY_FAIL = 'FETCH_TOKENKEY_FAIL';

const UPDATE_TOKENKEY_SUCCESS = 'UPDATE_TOKENKEY_SUCCESS';
const UPDATE_TOKENKEY_FAIL = 'UPDATE_TOKENKEY_FAIL';

const CREATE_DUITNOW_SUCCESS = 'CREATE_DUITNOW_SUCCESS';
const CREATE_DUITNOW_FAIL = 'CREATE_DUITNOW_FAIL';

const FETCH_DUITNOW_SUCCESS = 'FETCH_DUITNOW_SUCCESS';
const FETCH_DUITNOW_FAIL = 'FETCH_DUITNOW_FAIL';

const FETCH_TOKENKEY_DUITNOW_SUCCESS = 'FETCH_TOKENKEY_DUITNOW_SUCCESS';
const FETCH_TOKENKEY_DUITNOW_FAIL = 'FETCH_TOKENKEY_DUITNOW_FAIL';

const UPDATE_TOKENKEY_DUITNOW_SUCCESS = 'UPDATE_TOKENKEY_DUITNOW_SUCCESS';
const UPDATE_TOKENKEY_DUITNOW_FAIL = 'UPDATE_TOKENKEY_DUITNOW_FAIL';

const FETCH_TOKENKEY_RAZER_SUCCESS = 'FETCH_TOKENKEY_RAZER_SUCCESS';
const FETCH_TOKENKEY_RAZER_FAIL = 'FETCH_TOKENKEY_RAZER_FAIL';

const UPDATE_TOKENKEY_RAZER_SUCCESS = 'UPDATE_TOKENKEY_RAZER_SUCCESS';
const UPDATE_TOKENKEY_RAZER_FAIL = 'UPDATE_TOKENKEY_RAZER_FAIL';

const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
const CHANGE_PASSWORD_FAIL = 'CHANGE_PASSWORD_FAIL';

const LOYALTY_ADMIN_CHECK_SUCCESS = 'LOYALTY_ADMIN_CHECK_SUCCESS';
const LOYALTY_ADMIN_CHECK_FAIL = 'LOYALTY_ADMIN_CHECK_FAIL';

const SUMMARY_FILTER_SUCCESS = 'SUMMARY_FILTER_SUCCESS';
const SUMMARY_FILTER_FAIL = 'SUMMARY_FILTER_FAIL';

const SALES_PERFORMANCE_FILTER_SUCCESS = 'SALES_PERFORMANCE_FILTER_SUCCESS';
const SALES_PERFORMANCE_FILTER_FAIL = 'SALES_PERFORMANCE_FILTER_FAIL';

const MACHINE_UTIL_FILTER_SUCCESS = 'MACHINE_UTIL_FILTER_SUCCESS';
const MACHINE_UTIL_FILTER_FAIL = 'MACHINE_UTIL_FILTER_FAIL';

const CLEAR_FILTER_SUCCESS = 'CLEAR_FILTER_SUCCESS';

const FETCH_OPERATORS_SUCCESS = 'FETCH_OPERATORS_SUCCESS';
const FETCH_OPERATORS_FAIL = 'FETCH_OPERATORS_FAIL';

const FETCH_CONFIGS_FAIL = 'FETCH_CONFIGS_FAIL';

const UPDATE_RM_SUCCESS = 'UPDATE_RM_SUCCESS';
const UPDATE_RM_FAIL = 'UPDATE_RM_FAIL';

const UPDATE_RAZER_SUCCESS = 'UPDATE_RAZER_SUCCESS';
const UPDATE_RAZER_FAIL = 'UPDATE_RAZER_FAIL';

const UPDATE_DUITNOW_SUCCESS = 'UPDATE_DUITNOW_SUCCESS';
const UPDATE_DUITNOW_FAIL = 'UPDATE_DUITNOW_FAIL';

const DISTRIBUTOR_VERIFY_SUCCESS = 'DISTRIBUTOR_VERIFY_SUCCESS';
const DISTRIBUTOR_VERIFY_FAIL = 'DISTRIBUTOR_VERIFY_FAIL';

const OPERATOR_VERIFY_SUCCESS = 'OPERATOR_VERIFY_SUCCESS';
const OPERATOR_VERIFY_FAIL = 'OPERATOR_VERIFY_FAIL';

const STAFF_VERIFY_SUCCESS = 'STAFF_VERIFY_SUCCESS';
const STAFF_VERIFY_FAIL = 'STAFF_VERIFY_FAIL';

const FETCH_2FA_SUCCESS = 'FETCH_2FA_SUCCESS';
const FETCH_2FA_FAIL = 'FETCH_2FA_FAIL';

const USER_2FA_VERIFY_SUCCESS = 'USER_2FA_VERIFY_SUCCESS';
const USER_2FA_VERIFY_FAIL = 'USER_2FA_VERIFY_FAIL';

const CREATE_AMPERSANDPAY_SUCCESS = 'CREATE_AMPERSANDPAY_SUCCESS';
const CREATE_AMPERSANDPAY_FAIL = 'CREATE_AMPERSANDPAY_FAIL';

const FETCH_AMPERSANDPAY_SUCCESS = 'FETCH_AMPERSANDPAY_SUCCESS';
const FETCH_AMPERSANDPAY_FAIL = 'FETCH_AMPERSANDPAY_FAIL';

const UPDATE_AMPERSANDPAY_SUCCESS = 'UPDATE_AMPERSANDPAY_SUCCESS';
const UPDATE_AMPERSANDPAY_FAIL = 'UPDATE_AMPERSANDPAY_FAIL';

const CREATE_GHL_SUCCESS = 'CREATE_GHL_SUCCESS';
const CREATE_GHL_FAIL = 'CREATE_GHL_FAIL';

const FETCH_GHL_SUCCESS = 'FETCH_GHL_SUCCESS';
const FETCH_GHL_FAIL = 'FETCH_GHL_FAIL';

const UPDATE_GHL_SUCCESS = 'UPDATE_GHL_SUCCESS';
const UPDATE_GHL_FAIL = 'UPDATE_GHL_FAIL';

const FETCH_TOKENKEY_GHL_SUCCESS = 'FETCH_TOKENKEY_GHL_SUCCESS';
const FETCH_TOKENKEY_GHL_FAIL = 'FETCH_TOKENKEY_GHL_FAIL';

const UPDATE_TOKENKEY_GHL_SUCCESS = 'UPDATE_TOKENKEY_GHL_SUCCESS';
const UPDATE_TOKENKEY_GHL_FAIL = 'UPDATE_TOKENKEY_GHL_FAIL';

const CREATE_SCAN2PAY_SUCCESS = 'CREATE_SCAN2PAY_SUCCESS';
const CREATE_SCAN2PAY_FAIL = 'CREATE_SCAN2PAY_FAIL';

const FETCH_SCAN2PAY_SUCCESS = 'FETCH_SCAN2PAY_SUCCESS';
const FETCH_SCAN2PAY_FAIL = 'FETCH_SCAN2PAY_FAIL';

const UPDATE_SCAN2PAY_SUCCESS = 'UPDATE_SCAN2PAY_SUCCESS';
const UPDATE_SCAN2PAY_FAIL = 'UPDATE_SCAN2PAY_FAIL';

const FETCH_TOKENKEY_SCAN2PAY_SUCCESS = 'FETCH_TOKENKEY_SCAN2PAY_SUCCESS';
const FETCH_TOKENKEY_SCAN2PAY_FAIL = 'FETCH_TOKENKEY_SCAN2PAY_FAIL';

const UPDATE_TOKENKEY_SCAN2PAY_SUCCESS = 'UPDATE_TOKENKEY_SCAN2PAY_SUCCESS';
const UPDATE_TOKENKEY_SCAN2PAY_FAIL = 'UPDATE_TOKENKEY_SCAN2PAY_FAIL';


// KIPLE PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_KIPLE_SUCCESS = 'CREATE_KIPLE_SUCCESS';
const CREATE_KIPLE_FAIL = 'CREATE_KIPLE_FAIL';

const FETCH_KIPLE_SUCCESS = 'FETCH_KIPLE_SUCCESS';
const FETCH_KIPLE_FAIL = 'FETCH_KIPLE_FAIL';

const UPDATE_KIPLE_SUCCESS = 'UPDATE_KIPLE_SUCCESS';
const UPDATE_KIPLE_FAIL = 'UPDATE_KIPLE_FAIL';

const FETCH_TOKENKEY_KIPLE_SUCCESS = 'FETCH_TOKENKEY_KIPLE_SUCCESS'
const FETCH_TOKENKEY_KIPLE_FAIL = 'FETCH_TOKENKEY_KIPLE_FAIL'

const UPDATE_TOKENKEY_KIPLE_SUCCESS = 'UPDATE_TOKENKEY_KIPLE_SUCCESS';
const UPDATE_TOKENKEY_KIPLE_FAIL = 'UPDATE_TOKENKEY_KIPLE_FAIL';

// HITPAY PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_HITPAY_SUCCESS = 'CREATE_HITPAY_SUCCESS';
const CREATE_HITPAY_FAIL = 'CREATE_HITPAY_FAIL';

const FETCH_HITPAY_SUCCESS = 'FETCH_HITPAY_SUCCESS';
const FETCH_HITPAY_FAIL = 'FETCH_HITPAY_FAIL';

const UPDATE_HITPAY_SUCCESS = 'UPDATE_HITPAY_SUCCESS';
const UPDATE_HITPAY_FAIL = 'UPDATE_HITPAY_FAIL';

const FETCH_TOKENKEY_HITPAY_SUCCESS = 'FETCH_TOKENKEY_HITPAY_SUCCESS'
const FETCH_TOKENKEY_HITPAY_FAIL = 'FETCH_TOKENKEY_HITPAY_FAIL'

const UPDATE_TOKENKEY_HITPAY_SUCCESS = 'UPDATE_TOKENKEY_HITPAY_SUCCESS';
const UPDATE_TOKENKEY_HITPAY_FAIL = 'UPDATE_TOKENKEY_HITPAY_FAIL';

// PAGBANK PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_PAGBANK_SUCCESS = 'CREATE_PAGBANK_SUCCESS';
const CREATE_PAGBANK_FAIL = 'CREATE_PAGBANK_FAIL';

const FETCH_PAGBANK_SUCCESS = 'FETCH_PAGBANK_SUCCESS';
const FETCH_PAGBANK_FAIL = 'FETCH_PAGBANK_FAIL';

const UPDATE_PAGBANK_SUCCESS = 'UPDATE_PAGBANK_SUCCESS';
const UPDATE_PAGBANK_FAIL = 'UPDATE_PAGBANK_FAIL';

const FETCH_TOKENKEY_PAGBANK_SUCCESS = 'FETCH_TOKENKEY_PAGBANK_SUCCESS'
const FETCH_TOKENKEY_PAGBANK_FAIL = 'FETCH_TOKENKEY_PAGBANK_FAIL'

const UPDATE_TOKENKEY_PAGBANK_SUCCESS = 'UPDATE_TOKENKEY_PAGBANK_SUCCESS';
const UPDATE_TOKENKEY_PAGBANK_FAIL = 'UPDATE_TOKENKEY_PAGBANK_FAIL';

// 2C2P PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_2C2P_SUCCESS = 'CREATE_2C2P_SUCCESS';
const CREATE_2C2P_FAIL = 'CREATE_2C2P_FAIL';

const FETCH_2C2P_SUCCESS = 'FETCH_2C2P_SUCCESS';
const FETCH_2C2P_FAIL = 'FETCH_2C2P_FAIL';

const UPDATE_2C2P_SUCCESS = 'UPDATE_2C2P_SUCCESS';
const UPDATE_2C2P_FAIL = 'UPDATE_2C2P_FAIL';

const FETCH_TOKENKEY_2C2P_SUCCESS = 'FETCH_TOKENKEY_2C2P_SUCCESS'
const FETCH_TOKENKEY_2C2P_FAIL = 'FETCH_TOKENKEY_2C2P_FAIL'

const UPDATE_TOKENKEY_2C2P_SUCCESS = 'UPDATE_TOKENKEY_2C2P_SUCCESS';
const UPDATE_TOKENKEY_2C2P_FAIL = 'UPDATE_TOKENKEY_2C2P_FAIL';

// RHB PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_RHB_SUCCESS = 'CREATE_RHB_SUCCESS';
const CREATE_RHB_FAIL = 'CREATE_RHB_FAIL';

const FETCH_RHB_SUCCESS = 'FETCH_RHB_SUCCESS';
const FETCH_RHB_FAIL = 'FETCH_RHB_FAIL';

const UPDATE_RHB_SUCCESS = 'UPDATE_RHB_SUCCESS';
const UPDATE_RHB_FAIL = 'UPDATE_RHB_FAIL';

const FETCH_TOKENKEY_RHB_SUCCESS = 'FETCH_TOKENKEY_RHB_SUCCESS'
const FETCH_TOKENKEY_RHB_FAIL = 'FETCH_TOKENKEY_RHB_FAIL'

const UPDATE_TOKENKEY_RHB_SUCCESS = 'UPDATE_TOKENKEY_RHB_SUCCESS';
const UPDATE_TOKENKEY_RHB_FAIL = 'UPDATE_TOKENKEY_RHB_FAIL';

// CYBERSOURCE PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_CYBERSOURCE_SUCCESS = 'CREATE_CYBERSOURCE_SUCCESS';
const CREATE_CYBERSOURCE_FAIL = 'CREATE_CYBERSOURCE_FAIL';

const FETCH_CYBERSOURCE_SUCCESS = 'FETCH_CYBERSOURCE_SUCCESS';
const FETCH_CYBERSOURCE_FAIL = 'FETCH_CYBERSOURCE_FAIL';

const UPDATE_CYBERSOURCE_SUCCESS = 'UPDATE_CYBERSOURCE_SUCCESS';
const UPDATE_CYBERSOURCE_FAIL = 'UPDATE_CYBERSOURCE_FAIL';

const FETCH_TOKENKEY_CYBERSOURCE_SUCCESS = 'FETCH_TOKENKEY_CYBERSOURCE_SUCCESS'
const FETCH_TOKENKEY_CYBERSOURCE_FAIL = 'FETCH_TOKENKEY_CYBERSOURCE_FAIL'

const UPDATE_TOKENKEY_CYBERSOURCE_SUCCESS = 'UPDATE_TOKENKEY_CYBERSOURCE_SUCCESS';
const UPDATE_TOKENKEY_CYBERSOURCE_FAIL = 'UPDATE_TOKENKEY_CYBERSOURCE_FAIL';

const CHECKOUT_INVOICES_SUCCESS = 'CHECKOUT_INVOICES_SUCCESS';
const CHECKOUT_INVOICES_FAIL = 'CHECKOUT_INVOICES_FAIL';

const CHECKOUT_WITHOUT_CARD_SUCCESS = 'CHECKOUT_WITHOUT_CARD_SUCCESS';
const CHECKOUT_WITHOUT_CARD_FAIL = 'CHECKOUT_WITHOUT_CARD_FAIL';

const CREATE_CREDITCARD_SUCCESS = 'CREATE_CREDITCARD_SUCCESS';
const CREATE_CREDITCARD_FAIL = 'CREATE_CREDITCARD_FAIL';

const FETCH_CREDITCARD_SUCCESS = 'FETCH_CREDITCARD_SUCCESS';
const FETCH_CREDITCARD_FAIL = 'FETCH_CREDITCARD_FAIL';

const UPDATE_CREDITCARD_SUCCESS = 'UPDATE_CREDITCARD_SUCCESS';
const UPDATE_CREDITCARD_FAIL = 'UPDATE_CREDITCARD_FAIL';
// BANGKOK BANK PROMPTPAY PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_BANGKOKBANK_PROMPTPAY_SUCCESS = 'CREATE_BANGKOKBANK_PROMPTPAY_SUCCESS';
const CREATE_BANGKOKBANK_PROMPTPAY_FAIL = 'CREATE_BANGKOKBANK_PROMPTPAY_FAIL';

const FETCH_BANGKOKBANK_PROMPTPAY_SUCCESS = 'FETCH_BANGKOKBANK_PROMPTPAY_SUCCESS';
const FETCH_BANGKOKBANK_PROMPTPAY_FAIL = 'FETCH_BANGKOKBANK_PROMPTPAY_FAIL';

const UPDATE_BANGKOKBANK_PROMPTPAY_SUCCESS = 'UPDATE_BANGKOKBANK_PROMPTPAY_SUCCESS';
const UPDATE_BANGKOKBANK_PROMPTPAY_FAIL = 'UPDATE_BANGKOKBANK_PROMPTPAY_FAIL';

const FETCH_TOKENKEY_BANGKOKBANK_PROMPTPAY_SUCCESS = 'FETCH_TOKENKEY_BANGKOKBANK_PROMPTPAY_SUCCESS'
const FETCH_TOKENKEY_BANGKOKBANK_PROMPTPAY_FAIL = 'FETCH_TOKENKEY_BANGKOKBANK_PROMPTPAY_FAIL'

const UPDATE_TOKENKEY_BANGKOKBANK_PROMPTPAY_SUCCESS = 'UPDATE_TOKENKEY_BANGKOKBANK_PROMPTPAY_SUCCESS';
const UPDATE_TOKENKEY_BANGKOKBANK_PROMPTPAY_FAIL = 'UPDATE_TOKENKEY_BANGKOKBANK_PROMPTPAY_FAIL';

// BANGKOK BANK DEEPLINK PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_BANGKOKBANK_DEEPLINK_SUCCESS = 'CREATE_BANGKOKBANK_DEEPLINK_SUCCESS';
const CREATE_BANGKOKBANK_DEEPLINK_FAIL = 'CREATE_BANGKOKBANK_DEEPLINK_FAIL';

const FETCH_BANGKOKBANK_DEEPLINK_SUCCESS = 'FETCH_BANGKOKBANK_DEEPLINK_SUCCESS';
const FETCH_BANGKOKBANK_DEEPLINK_FAIL = 'FETCH_BANGKOKBANK_DEEPLINK_FAIL';

const UPDATE_BANGKOKBANK_DEEPLINK_SUCCESS = 'UPDATE_BANGKOKBANK_DEEPLINK_SUCCESS';
const UPDATE_BANGKOKBANK_DEEPLINK_FAIL = 'UPDATE_BANGKOKBANK_DEEPLINK_FAIL';

const FETCH_TOKENKEY_BANGKOKBANK_DEEPLINK_SUCCESS = 'FETCH_TOKENKEY_BANGKOKBANK_DEEPLINK_SUCCESS'
const FETCH_TOKENKEY_BANGKOKBANK_DEEPLINK_FAIL = 'FETCH_TOKENKEY_BANGKOKBANK_DEEPLINK_FAIL'

const UPDATE_TOKENKEY_BANGKOKBANK_DEEPLINK_SUCCESS = 'UPDATE_TOKENKEY_BANGKOKBANK_DEEPLINK_SUCCESS';
const UPDATE_TOKENKEY_BANGKOKBANK_DEEPLINK_FAIL = 'UPDATE_TOKENKEY_BANGKOKBANK_DEEPLINK_FAIL';

// PAYWAY PAYMENT GATEWAY OUTLET AND TOKEN CONFIG
const CREATE_PAYWAY_SUCCESS = 'CREATE_PAYWAY_SUCCESS';
const CREATE_PAYWAY_FAIL = 'CREATE_PAYWAY_FAIL';

const FETCH_PAYWAY_SUCCESS = 'FETCH_PAYWAY_SUCCESS';
const FETCH_PAYWAY_FAIL = 'FETCH_PAYWAY_FAIL';

const UPDATE_PAYWAY_SUCCESS = 'UPDATE_PAYWAY_SUCCESS';
const UPDATE_PAYWAY_FAIL = 'UPDATE_PAYWAY_FAIL';

const FETCH_TOKENKEY_PAYWAY_SUCCESS = 'FETCH_TOKENKEY_PAYWAY_SUCCESS'
const FETCH_TOKENKEY_PAYWAY_FAIL = 'FETCH_TOKENKEY_PAYWAY_FAIL'

const UPDATE_TOKENKEY_PAYWAY_SUCCESS = 'UPDATE_TOKENKEY_PAYWAY_SUCCESS';
const UPDATE_TOKENKEY_PAYWAY_FAIL = 'UPDATE_TOKENKEY_PAYWAY_FAIL';

// RAZER OPA (FIUU OFFLINE PAYMENT API - KIOSK DUITNOW QR) CONFIG
const CREATE_RAZER_OPA_SUCCESS = 'CREATE_RAZER_OPA_SUCCESS';
const CREATE_RAZER_OPA_FAIL = 'CREATE_RAZER_OPA_FAIL';

const FETCH_RAZER_OPA_SUCCESS = 'FETCH_RAZER_OPA_SUCCESS';
const FETCH_RAZER_OPA_FAIL = 'FETCH_RAZER_OPA_FAIL';

const UPDATE_RAZER_OPA_SUCCESS = 'UPDATE_RAZER_OPA_SUCCESS';
const UPDATE_RAZER_OPA_FAIL = 'UPDATE_RAZER_OPA_FAIL';

const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS';
const CREATE_COMPANY_FAIL = 'CREATE_COMPANY_FAIL';

const FETCH_COMPANY_SUCCESS = 'FETCH_COMPANY_SUCCESS';
const FETCH_COMPANY_FAIL = 'FETCH_COMPANY_FAIL';

const SEND_CHANGE_EMAIL_LINK_SUCCESS = 'SEND_CHANGE_EMAIL_LINK_SUCCESS';
const SEND_CHANGE_EMAIL_LINK_FAIL = 'SEND_CHANGE_EMAIL_LINK_FAIL';

const VERIFY_CHANGE_EMAIL_SUCCESS = 'VERIFY_CHANGE_EMAIL_SUCCESS';
const VERIFY_CHANGE_EMAIL_FAIL = 'VERIFY_CHANGE_EMAIL_FAIL';

const SAVE_USER_PREFERENCE_SUCCESS = 'SAVE_USER_PREFERENCE_SUCCESS';
const SAVE_USER_PREFERENCE_FAIL = 'SAVE_USER_PREFERENCE_FAIL';

const FETCH_USER_PREFERENCE_SUCCESS = 'FETCH_USER_PREFERENCE_SUCCESS';
const FETCH_USER_PREFERENCE_FAIL = 'FETCH_USER_PREFERENCE_FAIL';

const GET_RESOLVE_CONFIG_SUCCESS = 'GET_RESOLVE_CONFIG_SUCCESS';
const GET_RESOLVE_CONFIG_FAIL = 'GET_RESOLVE_CONFIG_FAIL';

const UPDATE_RESOLVE_CONFIG_SUCCESS = 'UPDATE_RESOLVE_CONFIG_SUCCESS';
const UPDATE_RESOLVE_CONFIG_FAIL = 'UPDATE_RESOLVE_CONFIG_FAIL';

const FETCH_NOTIFICATION_CREDENTIAL_SUCCESS = 'FETCH_NOTIFICATION_CREDENTIAL_SUCCESS';
const FETCH_NOTIFICATION_CREDENTIAL_FAIL = 'FETCH_NOTIFICATION_CREDENTIAL_FAIL';

const SAVE_NOTIFICATION_CREDENTIAL_SUCCESS = 'SAVE_NOTIFICATION_CREDENTIAL_SUCCESS';
const SAVE_NOTIFICATION_CREDENTIAL_FAIL = 'SAVE_NOTIFICATION_CREDENTIAL_FAIL';

const UNCONFIGURE_NOTIFICATION_CREDENTIAL_SUCCESS = 'UNCONFIGURE_NOTIFICATION_CREDENTIAL_SUCCESS';
const UNCONFIGURE_NOTIFICATION_CREDENTIAL_FAIL = 'UNCONFIGURE_NOTIFICATION_CREDENTIAL_FAIL';

const FETCH_NOTIFICATION_TEMPLATES_SUCCESS = 'FETCH_NOTIFICATION_TEMPLATES_SUCCESS';
const FETCH_NOTIFICATION_TEMPLATES_FAIL = 'FETCH_NOTIFICATION_TEMPLATES_FAIL';

const BLAST_EMAIL_SUCCESS = 'BLAST_EMAIL_SUCCESS';
const BLAST_EMAIL_FAIL = 'BLAST_EMAIL_FAIL';

const BLAST_SMS_SUCCESS = 'BLAST_SMS_SUCCESS';
const BLAST_SMS_FAIL = 'BLAST_SMS_FAIL';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';

export const updateRM = (RmDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateRMAction(RmDetails, token);

		dispatch({ type: UPDATE_RM_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_RM_FAIL, payload: returnError(error) });
	}
};

export const updateRazer = (RazerDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateRazerAction(RazerDetails, token);

		dispatch({ type: UPDATE_RAZER_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_RAZER_FAIL, payload: returnError(error) });
	}
};

export const updateDuitnow = (DuitnowDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateDuitnowAction(DuitnowDetails, token);

		dispatch({ type: UPDATE_DUITNOW_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_DUITNOW_FAIL, payload: returnError(error) });
	}
};

export const updateGhl = (GhlDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateGhlAction(GhlDetails, token);

		dispatch({ type: UPDATE_GHL_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_GHL_FAIL, payload: returnError(error) });
	}
};


export const registerOperator = (newUser) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = registerOperatorAction(newUser);

		dispatch({ type: USER_REGISTER_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: USER_REGISTER_FAIL, payload: returnError(error) });
	}
};

export const verifyOperator = (token, callback) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = verifyOperatorAction(token);
		// callback();
		dispatch({ type: USER_2FA_VERIFY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: USER_2FA_VERIFY_FAIL, payload: returnError(error) });
	}
};

export const loginStaff = (loginUser) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = await loginStaffAction(loginUser);

		// console.log(loginUser, data);

		dispatch({ type: STAFF_LOGIN_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: STAFF_LOGIN_FAIL, payload: returnError(error) });
	}
};

export const loginOperator = (loginUser) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = await loginOperatorAction(loginUser);

		// console.log(loginUser, data);

		dispatch({ type: OPERATOR_LOGIN_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: OPERATOR_LOGIN_FAIL, payload: returnError(error) });
	}
};

export const loginDistributor = (loginUser) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = await loginDistributorAction(loginUser);

		dispatch({ type: DISTRIBUTOR_LOGIN_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: DISTRIBUTOR_LOGIN_FAIL, payload: returnError(error) });
	}
};

export const loginClient = (loginUser) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = await loginClientAction(loginUser);

		dispatch({ type: CLIENT_LOGIN_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CLIENT_LOGIN_FAIL, payload: returnError(error) });
	}
};

export const createRM = (RmDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });

		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createRMAction(RmDetails, token);

		dispatch({ type: CREATE_RM_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_RM_FAIL, payload: returnError(error) });
	}
};

export const createRazer = (RazerDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });

		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createRazerAction(RazerDetails, token);

		dispatch({ type: CREATE_RAZER_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_RAZER_FAIL, payload: returnError(error) });
	}
};

export const createDuitnow = (DuitnowDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });

		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createDuitnowAction(DuitnowDetails, token);

		dispatch({ type: CREATE_DUITNOW_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_DUITNOW_FAIL, payload: returnError(error) });
	}
};

export const createGhl = (GhlDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });

		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createGhlAction(GhlDetails, token);

		dispatch({ type: CREATE_GHL_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_GHL_FAIL, payload: returnError(error) });
	}
};

export const createCreditcard = (creditCardDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createCreditcardAction(creditCardDetails, token);

		dispatch({ type: CREATE_CREDITCARD_SUCCESS, payload: data });
        return data;
	} catch (error) {
		dispatch({ type: CREATE_CREDITCARD_FAIL, payload: returnError(error) });
	}
};

export const fetchCreditcard = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchCreditcardAction(operatorId, token);

		dispatch({ type: FETCH_CREDITCARD_SUCCESS, payload: data.data });
        return data;
	} catch (error) {
		dispatch({ type: FETCH_CREDITCARD_FAIL, payload: returnError(error) });
	}
};

export const updateCreditcard = (creditCardDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateCreditcardAction(creditCardDetails, token);

		dispatch({ type: UPDATE_CREDITCARD_SUCCESS, payload: data });
        return data;
	} catch (error) {
		dispatch({ type: UPDATE_CREDITCARD_FAIL, payload: returnError(error) });
	}
};

export const checkUserSession = (token) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });

		const { data } = await checkSessionAction(token);

		dispatch({ type: USER_DETAILS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: USER_DETAILS_FAIL, payload: returnError(error) });
	}
};

export const fetchRM = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchRMAction(operatorId, token);
		// console.log('data', data.data);
		dispatch({ type: FETCH_RM_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_RM_FAIL, payload: returnError(error) });
	}
};

export const fetchRazer = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchRazerAction(operatorId, token);
		// console.log('data', data.data);
		dispatch({ type: FETCH_RAZER_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_RAZER_FAIL, payload: returnError(error) });
	}
};

export const checkoutInvoices = (checkoutPayload) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await checkoutInvoicesAction(checkoutPayload, token);

		dispatch({ type: CHECKOUT_INVOICES_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: CHECKOUT_INVOICES_FAIL, payload: returnError(error) });
	}
};

export const checkoutWithoutCard = (checkoutPayload) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await checkoutWithoutCardAction(checkoutPayload, token);

		dispatch({ type: CHECKOUT_WITHOUT_CARD_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: CHECKOUT_WITHOUT_CARD_FAIL, payload: returnError(error) });
	}
};

export const checkoutTopup = (reqBody) => async (dispatch, getState) => {
  try {
    const { user } = getState();
    const token = getToken(user);

    const { data } = await topupCheckoutAction(reqBody, token);
    // data.data is the payment engine payload: { type, url, body }
    return { ok: true, data: data.data };
  } catch (error) {
    return { ok: false, error: returnError(error) };
  }
};

export const fetchTopupCredentials = () => async (dispatch, getState) => {
  try {
    const { user } = getState();
    const token = getToken(user);

    const { data } = await (user.client && !user.distributor
      ? getClientUserCredentialAction({}, token)
      : getDistributorUserCredentialAction({}, token));
    // data.operators = [{ operatorId, username, email, sms, whatsapp }]
    return { ok: true, data: data.operators || [] };
  } catch (error) {
    return { ok: false, error: returnError(error) };
  }
};

export const fetchBillingContacts = (operatorId) => async (dispatch, getState) => {
  try {
    const { user } = getState();
    const token = getToken(user);

    const { data } = await fetchContactAction(token, operatorId);
    // data.data = [{ id, name }]
    return { ok: true, data: data.data || [] };
  } catch (error) {
    return { ok: false, error: returnError(error) };
  }
};

export const fetchGhl = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchGhlAction(operatorId, token);
		// console.log('data', data.data);
		dispatch({ type: FETCH_GHL_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_GHL_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkey =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_FAIL, payload: returnError(error) });
		}
	};

export const fetchTokenkey = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyRazer =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyRazerAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_RAZER_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_RAZER_FAIL, payload: returnError(error) });
		}
	};

export const updateTokenkeyGhl =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyGhlAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_GHL_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_GHL_FAIL, payload: returnError(error) });
		}
	};

export const updateTokenkeyScan2Pay =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyScan2PayAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_SCAN2PAY_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_SCAN2PAY_FAIL, payload: returnError(error) });
		}
	};

export const fetchTokenkeyRazer = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyRazerAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_RAZER_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_RAZER_FAIL, payload: returnError(error) });
	}
};

export const fetchTokenkeyGhl = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyGhlAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_GHL_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_GHL_FAIL, payload: returnError(error) });
	}
};

export const fetchTokenkeyScan2Pay = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyScan2PayAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_SCAN2PAY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_SCAN2PAY_FAIL, payload: returnError(error) });
	}
};

export const fetchDuitnow = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchDuitnowAction(operatorId, token);
		// console.log('data', data.data);
		dispatch({ type: FETCH_DUITNOW_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_DUITNOW_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyDuitnow =
	(tokenkeyDuitnowDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyDuitnowAction(tokenkeyDuitnowDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_DUITNOW_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_DUITNOW_FAIL, payload: returnError(error) });
		}
	};

export const fetchTokenkeyDuitnow = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyDuitnowAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_DUITNOW_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_DUITNOW_FAIL, payload: returnError(error) });
	}
};

export const loyaltyAdminCheck = () => async (dispatch, getState) => {
	const { user } = getState();
	const token = getToken(user);
	try {
		const { data } = await loyaltyAdminCheckAction(token);

		dispatch({ type: LOYALTY_ADMIN_CHECK_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: LOYALTY_ADMIN_CHECK_FAIL, payload: returnError(error) });
	}
};

export const fetchOperators = () => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const distributorToken = getToken(user);

		// Client users only see assigned operators; normalise to the distributor operator shape ({ id, username })
		if (user.client && !user.distributor && !user.operator && !user.staff) {
			const { data } = await getClientUserCredentialAction({}, distributorToken);
			const operators = (data.operators || []).map((o) => ({ ...o, id: o.operatorId }));
			dispatch({ type: FETCH_OPERATORS_SUCCESS, payload: { data: operators } });
			return;
		}

		const { data } = await fetchOperatorsAction(distributorToken);

		dispatch({ type: FETCH_OPERATORS_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_OPERATORS_FAIL, payload: returnError(error) });
	}
};

export const resetPassword = (body) => async (dispatch, getState) => {
	try {
		let reqBody = body;

		if (body?.inApp) {
			const { user } = getState();
			const token = getToken(user);
			reqBody.token = token;
		}

		const { data } = await resetPasswordAction(reqBody);
		return data;
	} catch (error) {
		return returnError(error);
	}
};


export const verifyDistributor = (id, otp) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = await verifyDistributorAction(id, otp);

		dispatch({ type: DISTRIBUTOR_VERIFY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: DISTRIBUTOR_VERIFY_FAIL, payload: returnError(error) });
	}
};


export const verifyOtpOperator = (id, otp) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = await verifyOtpOperatorAction(id, otp);

		dispatch({ type: OPERATOR_VERIFY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: OPERATOR_VERIFY_FAIL, payload: returnError(error) });
	}
};


export const verifyStaff = (id, otp) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = await verifyStaffAction(id, otp);

		dispatch({ type: STAFF_VERIFY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: STAFF_VERIFY_FAIL, payload: returnError(error) });
	}
};

export const verifyUser2fa = (sendBody) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await verifyUser2faAction(sendBody, token);

		dispatch({ type: USER_VERIFY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: USER_VERIFY_FAIL, payload: returnError(error) });
	}
};


export const sendResetEmail = (body) => async (dispatch) => {
	try {
		const { data } = await sendResetEmailAction(body);
		return data;
	} catch (error) {
		return returnError(error);
	}
};

export const fetch2FA = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetch2faAction(token);
		// console.log('data', data.data);
		dispatch({ type: FETCH_2FA_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_2FA_FAIL, payload: returnError(error) });
	}
};



export const createScan2Pay = (scan2PayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createScan2PayAction(scan2PayDetails, token);

		dispatch({ type: CREATE_SCAN2PAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_SCAN2PAY_FAIL, payload: returnError(error) });
	}
};

export const fetchScan2Pay = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchScan2PayAction(operatorId, token);

		dispatch({ type: FETCH_SCAN2PAY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_SCAN2PAY_FAIL, payload: returnError(error) });
	}
};

export const updateScan2Pay = (scan2PayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateScan2PayAction(scan2PayDetails, token);

		dispatch({ type: UPDATE_SCAN2PAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_SCAN2PAY_FAIL, payload: returnError(error) });
	}
};

///////// KIPLE PAYMENT GATEWAY OUTLET AND TOKEN CONFIG /////////
export const fetchTokenkeyKiple = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyKipleAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_KIPLE_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_KIPLE_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyKiple =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyKipleAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_KIPLE_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_KIPLE_FAIL, payload: returnError(error) });
		}
	};

export const createKiple = (KipleDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createKipleAction(KipleDetails, token);

		dispatch({ type: CREATE_KIPLE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_KIPLE_FAIL, payload: returnError(error) });
	}
};

export const fetchKiple = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchKipleAction(operatorId, token);

		dispatch({ type: FETCH_KIPLE_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_KIPLE_FAIL, payload: returnError(error) });
	}
};

export const updateKiple = (KipleDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateKipleAction(KipleDetails, token);

		dispatch({ type: UPDATE_KIPLE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_KIPLE_FAIL, payload: returnError(error) });
	}
};

///////// HITPAY PAYMENT GATEWAY OUTLET AND TOKEN CONFIG /////////
export const fetchTokenkeyHitpay = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyHitpayAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_HITPAY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_HITPAY_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyHitpay =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyHitpayAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_HITPAY_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_HITPAY_FAIL, payload: returnError(error) });
		}
	};

export const createHitpay = (HitpayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createHitpayAction(HitpayDetails, token);

		dispatch({ type: CREATE_HITPAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_HITPAY_FAIL, payload: returnError(error) });
	}
};

export const fetchHitpay = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchHitpayAction(operatorId, token);

		dispatch({ type: FETCH_HITPAY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_HITPAY_FAIL, payload: returnError(error) });
	}
};

export const updateHitpay = (HitpayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateHitpayAction(HitpayDetails, token);

		dispatch({ type: UPDATE_HITPAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_HITPAY_FAIL, payload: returnError(error) });
	}
};

///////// PAGBANK PAYMENT GATEWAY OUTLET AND TOKEN CONFIG /////////
export const fetchTokenkeyPagbank = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyPagbankAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_PAGBANK_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_PAGBANK_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyPagbank =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyPagbankAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_PAGBANK_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_PAGBANK_FAIL, payload: returnError(error) });
		}
	};

export const createPagbank = (PagbankDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createPagbankAction(PagbankDetails, token);

		dispatch({ type: CREATE_PAGBANK_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_PAGBANK_FAIL, payload: returnError(error) });
	}
};

export const fetchPagbank = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchPagbankAction(operatorId, token);

		dispatch({ type: FETCH_PAGBANK_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_PAGBANK_FAIL, payload: returnError(error) });
	}
};

export const updatePagbank = (PagbankDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updatePagbankAction(PagbankDetails, token);

		dispatch({ type: UPDATE_PAGBANK_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_PAGBANK_FAIL, payload: returnError(error) });
	}
};

///////// 2C2P PAYMENT GATEWAY OUTLET AND TOKEN CONFIG /////////
export const fetchTokenkey2c2p = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkey2c2pAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_2C2P_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_2C2P_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkey2c2p =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkey2c2pAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_2C2P_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_2C2P_FAIL, payload: returnError(error) });
		}
	};

export const create2c2p = (TwoCTwoPDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await create2c2pAction(TwoCTwoPDetails, token);

		dispatch({ type: CREATE_2C2P_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_2C2P_FAIL, payload: returnError(error) });
	}
};

export const fetch2c2p = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetch2c2pAction(operatorId, token);

		dispatch({ type: FETCH_2C2P_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_2C2P_FAIL, payload: returnError(error) });
	}
};

export const update2c2p = (TwoCTwoPDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await update2c2pAction(TwoCTwoPDetails, token);

		dispatch({ type: UPDATE_2C2P_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_2C2P_FAIL, payload: returnError(error) });
	}
};

///////// Rhb PAYMENT GATEWAY OUTLET AND TOKEN CONFIG /////////
export const fetchTokenkeyRhb = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyRhbAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_RHB_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_RHB_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyRhb =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyRhbAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_RHB_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_RHB_FAIL, payload: returnError(error) });
		}
	};

export const createRhb = (TwoCTwoPDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createRhbAction(TwoCTwoPDetails, token);

		dispatch({ type: CREATE_RHB_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_RHB_FAIL, payload: returnError(error) });
	}
};

export const fetchRhb = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchRhbAction(operatorId, token);

		dispatch({ type: FETCH_RHB_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_RHB_FAIL, payload: returnError(error) });
	}
};

export const updateRhb = (rhbDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateRhbAction(rhbDetails, token);

		dispatch({ type: UPDATE_RHB_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_RHB_FAIL, payload: returnError(error) });
	}
};


export const createAmpersandPay = (ampersandPayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createAmpersandPayAction(ampersandPayDetails, token);

		dispatch({ type: CREATE_AMPERSANDPAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_AMPERSANDPAY_FAIL, payload: returnError(error) });
	}
};

export const fetchAmpersandPay = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchAmpersandPayAction(operatorId, token);

		dispatch({ type: FETCH_AMPERSANDPAY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_AMPERSANDPAY_FAIL, payload: returnError(error) });
	}
};

export const updateAmpersandPay = (ampersandPayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateAmpersandPayAction(ampersandPayDetails, token);

		dispatch({ type: UPDATE_AMPERSANDPAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_AMPERSANDPAY_FAIL, payload: returnError(error) });
	}
};

///////// CYBERSOURCE PAYMENT GATEWAY OUTLET AND TOKEN CONFIG /////////
export const fetchTokenkeyCybersource = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyCybersourceAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_CYBERSOURCE_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_CYBERSOURCE_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyCybersource =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyCybersourceAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_CYBERSOURCE_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_CYBERSOURCE_FAIL, payload: returnError(error) });
		}
	};

export const createCybersource = (cybersourceDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createCybersourceAction(cybersourceDetails, token);

		dispatch({ type: CREATE_CYBERSOURCE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_CYBERSOURCE_FAIL, payload: returnError(error) });
	}
};

export const fetchCybersource = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchCybersourceAction(operatorId, token);

		dispatch({ type: FETCH_CYBERSOURCE_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_CYBERSOURCE_FAIL, payload: returnError(error) });
	}
};

export const updateCybersource = (CybersourceDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateCybersourceAction(CybersourceDetails, token);

		dispatch({ type: UPDATE_CYBERSOURCE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_CYBERSOURCE_FAIL, payload: returnError(error) });
	}
};

///////// BANGKOK BANK PROMPTPAY PAYMENT GATEWAY OUTLET AND TOKEN CONFIG /////////
export const fetchTokenkeyBangkokBankPromptPay = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyBangkokBankPromptPayAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_BANGKOKBANK_PROMPTPAY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_BANGKOKBANK_PROMPTPAY_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyBangkokBankPromptPay =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyBangkokBankPromptPayAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_BANGKOKBANK_PROMPTPAY_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_BANGKOKBANK_PROMPTPAY_FAIL, payload: returnError(error) });
		}
	};

export const createBangkokBankPromptPay = (bangkokBankPromptPayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createBangkokBankPromptPayAction(bangkokBankPromptPayDetails, token);

		dispatch({ type: CREATE_BANGKOKBANK_PROMPTPAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_BANGKOKBANK_PROMPTPAY_FAIL, payload: returnError(error) });
	}
};

export const fetchBangkokBankPromptPay = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchBangkokBankPromptPayAction(operatorId, token);

		dispatch({ type: FETCH_BANGKOKBANK_PROMPTPAY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_BANGKOKBANK_PROMPTPAY_FAIL, payload: returnError(error) });
	}
};

export const updateBangkokBankPromptPay = (BangkokBankPromptPayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateBangkokBankPromptPayAction(BangkokBankPromptPayDetails, token);

		dispatch({ type: UPDATE_BANGKOKBANK_PROMPTPAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_BANGKOKBANK_PROMPTPAY_FAIL, payload: returnError(error) });
	}
};

///////// BANGKOK BANK DEEPLINK PAYMENT GATEWAY OUTLET AND TOKEN CONFIG /////////
export const fetchTokenkeyBangkokBankDeeplink = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();

		const token = getToken(user);

		const { data } = await fetchTokenkeyBangkokBankDeeplinkAction(operatorId, token);

		dispatch({ type: FETCH_TOKENKEY_BANGKOKBANK_DEEPLINK_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_TOKENKEY_BANGKOKBANK_DEEPLINK_FAIL, payload: returnError(error) });
	}
};

export const updateTokenkeyBangkokBankDeeplink =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyBangkokBankDeeplinkAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_BANGKOKBANK_DEEPLINK_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_BANGKOKBANK_DEEPLINK_FAIL, payload: returnError(error) });
		}
	};

export const createBangkokBankDeeplink = (bangkokBankDeeplinkDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createBangkokBankDeeplinkAction(bangkokBankDeeplinkDetails, token);

		dispatch({ type: CREATE_BANGKOKBANK_DEEPLINK_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_BANGKOKBANK_DEEPLINK_FAIL, payload: returnError(error) });
	}
};

export const fetchBangkokBankDeeplink = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchBangkokBankDeeplinkAction(operatorId, token);

		dispatch({ type: FETCH_BANGKOKBANK_DEEPLINK_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_BANGKOKBANK_DEEPLINK_FAIL, payload: returnError(error) });
	}
};

export const updateBangkokBankDeeplink = (BangkokBankDeeplinkDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateBangkokBankDeeplinkAction(BangkokBankDeeplinkDetails, token);

		dispatch({ type: UPDATE_BANGKOKBANK_DEEPLINK_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_BANGKOKBANK_DEEPLINK_FAIL, payload: returnError(error) });
	}
};

export const fetchTokenkeyPayway =
	(operatorId) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await fetchTokenkeyPaywayAction(operatorId, token);

			dispatch({ type: FETCH_TOKENKEY_PAYWAY_SUCCESS, payload: data.data });
		} catch (error) {
			dispatch({ type: FETCH_TOKENKEY_PAYWAY_FAIL, payload: returnError(error) });
		}
	};

export const updateTokenkeyPayway =
	(tokenkeyDetails) => async (dispatch, getState) => {
		try {
			dispatch({ type: CLEAR_USER_ERROR });
			dispatch({ type: SET_USER_LOADING });

			const { user } = getState();

			const token = getToken(user);

			const { data } = await tokenkeyPaywayAction(tokenkeyDetails, token);

			dispatch({ type: UPDATE_TOKENKEY_PAYWAY_SUCCESS, payload: data });
		} catch (error) {
			dispatch({ type: UPDATE_TOKENKEY_PAYWAY_FAIL, payload: returnError(error) });
		}
	};

export const createPayway = (paywayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createPaywayAction(paywayDetails, token);

		dispatch({ type: CREATE_PAYWAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_PAYWAY_FAIL, payload: returnError(error) });
	}
};

export const fetchPayway = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchPaywayAction(operatorId, token);

		dispatch({ type: FETCH_PAYWAY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_PAYWAY_FAIL, payload: returnError(error) });
	}
};

export const updatePayway = (PaywayDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updatePaywayAction(PaywayDetails, token);

		dispatch({ type: UPDATE_PAYWAY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_PAYWAY_FAIL, payload: returnError(error) });
	}
};

export const createRazerOpa = (razerOpaDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createRazerOpaAction(razerOpaDetails, token);

		dispatch({ type: CREATE_RAZER_OPA_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_RAZER_OPA_FAIL, payload: returnError(error) });
	}
};

export const fetchRazerOpa = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchRazerOpaAction(operatorId, token);

		dispatch({ type: FETCH_RAZER_OPA_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_RAZER_OPA_FAIL, payload: returnError(error) });
	}
};

export const updateRazerOpa = (RazerOpaDetails) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateRazerOpaAction(RazerOpaDetails, token);

		dispatch({ type: UPDATE_RAZER_OPA_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: UPDATE_RAZER_OPA_FAIL, payload: returnError(error) });
	}
};

export const createCompany = (companyDetauls) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await createCompanyAction(companyDetauls, token);

		dispatch({ type: CREATE_COMPANY_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: CREATE_COMPANY_FAIL, payload: returnError(error) });
	}
};

export const fetchCompany = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchCompanyAction(operatorId, token);

		dispatch({ type: FETCH_COMPANY_SUCCESS, payload: data.data });
	} catch (error) {
		dispatch({ type: FETCH_COMPANY_FAIL, payload: returnError(error) });
	}
};

export const sendChangeEmailLink = (body) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await sendChangeEmailLinkAction(body, token);

		dispatch({ type: SEND_CHANGE_EMAIL_LINK_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: SEND_CHANGE_EMAIL_LINK_FAIL, payload: returnError(error) });
	}
};

export const verifyChangeEmailLink = (token) => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { data } = await verifyChangeEmailLinkAction(token);

		dispatch({ type: VERIFY_CHANGE_EMAIL_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: VERIFY_CHANGE_EMAIL_FAIL, payload: returnError(error) });
	}
};

export const saveUserPreference = (preference) => async (dispatch, getState) => {
	try {
		const { user } = getState();
		const token = getToken(user);

		await saveUserPreferenceAction(preference, token);
		const { data } = await fetchUserPreferenceAction(token);
		dispatch({ type: SAVE_USER_PREFERENCE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: SAVE_USER_PREFERENCE_FAIL, payload: returnError(error) });
	}
};

export const fetchUserPreference = () => async (dispatch, getState) => {
	try {
		const { user } = getState();
		const token = getToken(user);

		const { data } = await fetchUserPreferenceAction(token);
		dispatch({ type: FETCH_USER_PREFERENCE_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: FETCH_USER_PREFERENCE_FAIL, payload: returnError(error) });
	}
};

export const getResolveConfig = () => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await getResolveConfigAction({}, token);

		dispatch({ type: GET_RESOLVE_CONFIG_SUCCESS, payload: data });
	} catch (error) {
		dispatch({ type: GET_RESOLVE_CONFIG_FAIL, payload: returnError(error) });
	}
};

export const updateResolveConfig = (body) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await updateResolveConfigAction(body, token);

		dispatch({ type: UPDATE_RESOLVE_CONFIG_SUCCESS, payload: data });
		return data; // add this
	} catch (error) {
		const err = returnError(error);
		dispatch({ type: UPDATE_RESOLVE_CONFIG_FAIL, payload: err });
		return { error: err }; // add this
	}
};

export const fetchNotificationCredential = (operatorId) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		const { user } = getState();
		const token = getToken(user);

		const { data } = await getNotificationCredentialAction(token, operatorId);
		dispatch({ type: FETCH_NOTIFICATION_CREDENTIAL_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: FETCH_NOTIFICATION_CREDENTIAL_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const addNotificationCredential = (payload) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await addNotificationCredentialAction(payload, token);
		dispatch({ type: SAVE_NOTIFICATION_CREDENTIAL_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: SAVE_NOTIFICATION_CREDENTIAL_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const unconfigureNotificationCredential = (payload) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await unconfigureNotificationCredentialAction(payload, token);
		dispatch({ type: UNCONFIGURE_NOTIFICATION_CREDENTIAL_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: UNCONFIGURE_NOTIFICATION_CREDENTIAL_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const fetchNotificationTemplates = (payload) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await getNotificationTemplatesAction(payload, token);
		dispatch({ type: FETCH_NOTIFICATION_TEMPLATES_SUCCESS, payload: data?.templates || [] });
		return data;
	} catch (error) {
		dispatch({ type: FETCH_NOTIFICATION_TEMPLATES_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const blastEmailNotification = (payload) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await blastEmailAction(payload, token);
		dispatch({ type: BLAST_EMAIL_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: BLAST_EMAIL_FAIL, payload: returnError(error) });
		throw error;
	}
};

export const blastSmsNotification = (payload) => async (dispatch, getState) => {
	try {
		dispatch({ type: CLEAR_USER_ERROR });
		dispatch({ type: SET_USER_LOADING });

		const { user } = getState();
		const token = getToken(user);

		const { data } = await blastSmsAction(payload, token);
		dispatch({ type: BLAST_SMS_SUCCESS, payload: data });
		return data;
	} catch (error) {
		dispatch({ type: BLAST_SMS_FAIL, payload: returnError(error) });
		throw error;
	}
};

const initialState = {
	language: 'en',
	operator: null,
	error: null,
	loading: false,
	rmExist: [],
	razerExist: [],
	ghlExist: [],
	tokenKey: [],
	tokenKeyRazer: [],
	tokenKeyGhl: [],
	duitnowExist: [],
	tokenKeyDuitnow: [],
	loyaltyToken: null,
	staffToken: localStorage.getItem('laundro-v2-staff-token'),
	operatorToken: localStorage.getItem('laundro-v2-operator-token'),
	distributorToken: localStorage.getItem('laundro-v2-distributor-token'),
	clientToken: localStorage.getItem('laundro-v2-client-token'),
	operators: [],
	distributor: null,
	staff: null,
	rmConfig: [],
	razerConfig: [],
	duitnowConfig: [],
	ampersandPay: [],
	ampersandPayExist: [],
	ghlConfig: [],
	scan2PayExist: [],
	scan2pay: [],
	tokenKeyScan2Pay: [],
	tokenConfigKeyScan2Pay: [],
	tokenKeyKiple: [],
	tokenConfigKeyKiple: [],
	kiple: [],
	kipleExist: [],
	tokenKeyHitpay: [],
	tokenConfigKeyHitpay: [],
	hitpay: [],
	hitpayExist: [],
	tokenKeyPagbank: [],
	tokenConfigKeyPagbank: [],
	pagbank: [],
	pagbankExist: [],
	tokenKey2c2p: [],
	tokenConfigKey2c2p: [],
	twoc2p: [],
	twoc2pExist: [],
	tokenKeyRhb: [],
	tokenConfigKeyRhb: [],
	rhb: [],
	rhbExist: [],
	cybersource: [],
	cybersourceExist: [],
	tokenKeyCybersource: [],
	tokenConfigKeyCybersource: [],
	creditcard: [],
	creditcardExist: [],
	bangkokBankPromptPay: [],
	bangkokBankPromptPayExist: [],
	tokenKeyBangkokBankPromptPay: [],
	tokenConfigKeyBangkokBankPromptPay: [],
	bangkokBankDeeplink: [],
	bangkokBankDeeplinkExist: [],
	tokenKeyBangkokBankDeeplink: [],
	tokenConfigKeyBangkokBankDeeplink: [],
	payway: [],
	paywayExist: [],
	tokenKeyPayway: [],
	tokenConfigKeyPayway: [],
	razerOpa: [],
	razerOpaExist: [],
	company: [],
	companyExist: [],
	changeEmailLinkStatus: null,
	verifyChangeEmailStatus: null,
	changeEmailerror: null,
	userPreference: null,
	notificationCredential: null,
	notificationTemplates: [],
};

export const userReducer = function (state = initialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SET_USER_LOADING:
			return {
				...state,
				loading: true,
				error: null,
			};

		case CLEAR_USER_ERROR:
			return {
				...state,
				error: null,
			};

		case CREATE_RM_SUCCESS:
			return {
				...state,
				rm: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_RM_SUCCESS:
			return {
				...state,
				rm: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_RM_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case UPDATE_RAZER_SUCCESS:
			return {
				...state,
				razer: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_RAZER_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case UPDATE_GHL_SUCCESS:
			return {
				...state,
				ghl: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_GHL_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case UPDATE_DUITNOW_SUCCESS:
			return {
				...state,
				duitnow: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_DUITNOW_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};


		case CREATE_RAZER_SUCCESS:
			return {
				...state,
				razer: action.payload,
				loading: false,
				error: null,
			};

		case CREATE_GHL_SUCCESS:
			return {
				...state,
				ghl: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_RM_SUCCESS:
			return {
				...state,
				rmExist: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_RAZER_SUCCESS:
			return {
				...state,
				razerExist: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_GHL_SUCCESS:
			return {
				...state,
				ghlExist: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_CREDITCARD_SUCCESS:
			return {
				...state,
				creditcardExist: action.payload,
				loading: false,
				error: null,
			};

		case CREATE_CREDITCARD_SUCCESS:
			return {
				...state,
				creditcard: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_CREDITCARD_SUCCESS:
			return {
				...state,
				creditcard: action.payload,
				loading: false,
				error: null,
			};

		case CHECKOUT_INVOICES_SUCCESS:
			return {
				...state,
				lastCheckout: action.payload,
				loading: false,
				error: null,
			};

		case CHECKOUT_WITHOUT_CARD_SUCCESS:
			return {
				...state,
				lastCheckout: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_CONFIGS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case UPDATE_TOKENKEY_SUCCESS:
			return {
				...state,
				tokenConfigKey: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_TOKENKEY_SUCCESS:
			return {
				...state,
				tokenKey: action.payload,
				loading: false,
				error: null,
			};

		case CREATE_DUITNOW_SUCCESS:
			return {
				...state,
				duitnow: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_DUITNOW_SUCCESS:
			return {
				...state,
				duitnowExist: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_TOKENKEY_DUITNOW_SUCCESS:
			return {
				...state,
				tokenConfigKeyDuitnow: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_TOKENKEY_DUITNOW_SUCCESS:
			return {
				...state,
				tokenKeyDuitnow: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_TOKENKEY_RAZER_SUCCESS:
			return {
				...state,
				tokenConfigKeyRazer: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_TOKENKEY_RAZER_SUCCESS:
			return {
				...state,
				tokenKeyRazer: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_TOKENKEY_GHL_SUCCESS:
			return {
				...state,
				tokenConfigKeyGhl: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_TOKENKEY_SCAN2PAY_SUCCESS:
			return {
				...state,
				tokenConfigKeyScan2Pay: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_TOKENKEY_KIPLE_SUCCESS:
			return {
				...state,
				tokenConfigKeyKiple: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_TOKENKEY_GHL_SUCCESS:
			return {
				...state,
				tokenKeyGhl: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_TOKENKEY_SCAN2PAY_SUCCESS:
			return {
				...state,
				tokenKeyScan2Pay: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_KIPLE_SUCCESS:
			return {
				...state,
				tokenKeyKiple: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_SCAN2PAY_SUCCESS:
			return {
				...state,
				scan2pay: action.payload,
				loading: false,
				error: null,
			};

		case CREATE_SCAN2PAY_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case FETCH_SCAN2PAY_SUCCESS:
			return {
				...state,
				scan2PayExist: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_SCAN2PAY_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case UPDATE_SCAN2PAY_SUCCESS:
			return {
				...state,
				scan2pay: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_SCAN2PAY_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case UPDATE_KIPLE_SUCCESS:
			return {
				...state,
				kiple: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_KIPLE_SUCCESS:
			return {
				...state,
				kipleExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_KIPLE_SUCCESS:
			return {
				...state,
				kiple: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_HITPAY_SUCCESS:
			return {
				...state,
				hitpay: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_HITPAY_SUCCESS:
			return {
				...state,
				hitpayExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_HITPAY_SUCCESS:
			return {
				...state,
				hitpay: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_HITPAY_SUCCESS:
			return {
				...state,
				tokenKey2c2p: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_TOKENKEY_HITPAY_SUCCESS:
			return {
				...state,
				tokenConfigKeyHitpay: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_PAGBANK_SUCCESS:
			return {
				...state,
				pagbank: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_PAGBANK_SUCCESS:
			return {
				...state,
				pagbankExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_PAGBANK_SUCCESS:
			return {
				...state,
				pagbank: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_PAGBANK_SUCCESS:
			return {
				...state,
				tokenKeyPagbank: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_TOKENKEY_PAGBANK_SUCCESS:
			return {
				...state,
				tokenConfigKeyPagbank: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_2C2P_SUCCESS:
			return {
				...state,
				twoc2p: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_2C2P_SUCCESS:
			return {
				...state,
				twoc2pExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_2C2P_SUCCESS:
			return {
				...state,
				twoc2p: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_2C2P_SUCCESS:
			return {
				...state,
				tokenKeyPagbank: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_TOKENKEY_2C2P_SUCCESS:
			return {
				...state,
				tokenConfigKey2c2p: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_RHB_SUCCESS:
			return {
				...state,
				rhb: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_RHB_SUCCESS:
			return {
				...state,
				rhbExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_RHB_SUCCESS:
			return {
				...state,
				rhb: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_RHB_SUCCESS:
			return {
				...state,
				tokenKeyRhb: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_TOKENKEY_RHB_SUCCESS:
			return {
				...state,
				tokenConfigKeyRhb: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_CYBERSOURCE_SUCCESS:
			return {
				...state,
				cybersource: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_CYBERSOURCE_SUCCESS:
			return {
				...state,
				cybersourceExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_CYBERSOURCE_SUCCESS:
			return {
				...state,
				cybersource: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_CYBERSOURCE_SUCCESS:
			return {
				...state,
				tokenKeyCybersource: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_TOKENKEY_CYBERSOURCE_SUCCESS:
			return {
				...state,
				tokenConfigKeyCybersource: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_BANGKOKBANK_PROMPTPAY_SUCCESS:
			return {
				...state,
				bangkokBankPromptPay: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_BANGKOKBANK_PROMPTPAY_SUCCESS:
			return {
				...state,
				bangkokBankPromptPayExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_BANGKOKBANK_PROMPTPAY_SUCCESS:
			return {
				...state,
				bangkokBankPromptPay: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_BANGKOKBANK_PROMPTPAY_SUCCESS:
			return {
				...state,
				tokenKeyBangkokBankPromptPay: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_TOKENKEY_BANGKOKBANK_PROMPTPAY_SUCCESS:
			return {
				...state,
				tokenConfigKeyBangkokBankPromptPay: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_BANGKOKBANK_DEEPLINK_SUCCESS:
			return {
				...state,
				bangkokBankDeeplink: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_BANGKOKBANK_DEEPLINK_SUCCESS:
			return {
				...state,
				bangkokBankDeeplinkExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_BANGKOKBANK_DEEPLINK_SUCCESS:
			return {
				...state,
				bangkokBankDeeplink: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_BANGKOKBANK_DEEPLINK_SUCCESS:
			return {
				...state,
				tokenKeyBangkokBankDeeplink: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_TOKENKEY_BANGKOKBANK_DEEPLINK_SUCCESS:
			return {
				...state,
				tokenConfigKeyBangkokBankDeeplink: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_PAYWAY_SUCCESS:
			return {
				...state,
				payway: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_PAYWAY_SUCCESS:
			return {
				...state,
				paywayExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_PAYWAY_SUCCESS:
			return {
				...state,
				payway: action.payload,
				loading: false,
				error: null,
			}

		case FETCH_TOKENKEY_PAYWAY_SUCCESS:
			return {
				...state,
				tokenKeyPayway: action.payload,
				loading: false,
				error: null,
			}

		case UPDATE_TOKENKEY_PAYWAY_SUCCESS:
			return {
				...state,
				tokenConfigKeyPayway: action.payload,
				loading: false,
				error: null,
			};

		case CREATE_RAZER_OPA_SUCCESS:
			return {
				...state,
				razerOpa: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_RAZER_OPA_SUCCESS:
			return {
				...state,
				razerOpaExist: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_RAZER_OPA_SUCCESS:
			return {
				...state,
				razerOpa: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_COMPANY_SUCCESS:
			return {
				...state,
				companyExist: action.payload,
				loading: false,
				error: null,
			}

		case CREATE_COMPANY_SUCCESS:
			return {
				...state,
				company: action.payload,
				loading: false,
				error: null,
			}


		case STAFF_LOGIN_SUCCESS:
			// console.log('action.payload.', action.payload);
			if (action.payload.role === 'staff') {
				localStorage.setItem('laundro-v2-staff-token', action.payload.token);
			}

			return {
				...state,
				[action.payload.role]: action.payload,
				[`${action.payload.role}Token`]: action.payload.token,
				loading: false,
				error: null,
			};

		// user login and registration success
		case OPERATOR_LOGIN_SUCCESS:
			// console.log('action.payload.', action.payload);
			if (action.payload.role === 'operator') {
				localStorage.setItem('laundro-v2-operator-token', action.payload.token);
			}

			return {
				...state,
				[action.payload.role]: action.payload,
				[`${action.payload.role}Token`]: action.payload.token,
				loading: false,
				error: null,
			};
		case CLIENT_LOGIN_SUCCESS:
			if (action.payload.role === 'client') {
				localStorage.setItem('laundro-v2-client-token', action.payload.token);
			}

			return {
				...state,
				[action.payload.role]: action.payload,
				[`${action.payload.role}Token`]: action.payload.token,
				loading: false,
				error: null,
			};

		case DISTRIBUTOR_LOGIN_SUCCESS:
			if (action.payload.role === 'distributor') {
				localStorage.setItem('laundro-v2-distributor-token', action.payload.token);
			}

			return {
				...state,
				[action.payload.role]: action.payload,
				[`${action.payload.role}Token`]: action.payload.token,
				loading: false,
				error: null,
			};

		case USER_REGISTER_SUCCESS:
		case USER_DETAILS_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				[action.payload.role]: action.payload,
				loading: false,
				error: null,
			};

		case CHANGE_PASSWORD_SUCCESS:
			// console.log("action.payload", action.payload);
			return {
				...state,
				password: action.payload,
				loading: false,
				error: null,
			};

		case LOYALTY_ADMIN_CHECK_SUCCESS:
			return {
				...state,
				loyaltyToken: action.payload.data,
				error: null,
			};

		case FETCH_OPERATORS_SUCCESS:
			// console.log('action.payload', action.payload);
			return {
				...state,
				operators: action.payload.data,
				loading: false,
				error: null,
			};

		case DISTRIBUTOR_VERIFY_SUCCESS:
			return {
				...state,
				authenticated: action.payload,
				loading: false,
				error: null,
			};

		case OPERATOR_VERIFY_SUCCESS:
			return {
				...state,
				authenticated: action.payload,
				loading: false,
				error: null,
			};

		case STAFF_VERIFY_SUCCESS:
			return {
				...state,
				authenticated: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_2FA_SUCCESS:
			return {
				...state,
				mfa: action.payload,
				loading: false,
				error: null,
			};

		case USER_2FA_VERIFY_SUCCESS:
			return {
				...state,
				authenticated: action.payload,
				loading: false,
				error: null,
			};

		case USER_VERIFY_SUCCESS:
			return {
				...state,
				authenticated2: action.payload,
				loading: false,
				error: null,
			};

		case CREATE_DUITNOW_FAIL:
			return {
				...state,
				loading: false,
				duitnowerror: action.payload,
			}


		case CREATE_COMPANY_FAIL:
			return {
				...state,
				loading: false,
				duitnowerror: action.payload,
			}

		case CREATE_AMPERSANDPAY_SUCCESS:
			return {
				...state,
				ampersandPay: action.payload,
				loading: false,
				error: null,
			};

		case FETCH_AMPERSANDPAY_SUCCESS:
			return {
				...state,
				ampersandPayExist: action.payload,
				loading: false,
				error: null,
			};

		case UPDATE_AMPERSANDPAY_SUCCESS:
			return {
				...state,
				ampersandPay: action.payload,
				loading: false,
				error: null,
			};

		case SEND_CHANGE_EMAIL_LINK_SUCCESS:
			return {
				...state,
				changeEmailLinkStatus: action.payload,
				loading: false,
				changeEmailerror: null,
			};

		case SEND_CHANGE_EMAIL_LINK_FAIL:
			return {
				...state,
				changeEmailLinkStatus: null,
				loading: false,
				changeEmailerror: action.payload,
			};

		case VERIFY_CHANGE_EMAIL_SUCCESS:
			return {
				...state,
				verifyChangeEmailStatus: action.payload,
				loading: false,
				changeEmailerror: null,
			};

		case VERIFY_CHANGE_EMAIL_FAIL:
			return {
				...state,
				verifyChangeEmailStatus: null,
				loading: false,
				changeEmailerror: action.payload,
			};

		case SAVE_USER_PREFERENCE_SUCCESS:
			return {
				...state,
				userPreference: action.payload,
				loading: false,
			};

		case SAVE_USER_PREFERENCE_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case FETCH_USER_PREFERENCE_SUCCESS:
			return {
				...state,
				userPreference: action.payload,
				loading: false,
			};

		case FETCH_USER_PREFERENCE_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case GET_RESOLVE_CONFIG_SUCCESS:
			return {
				...state,
				resolveConfig: action.payload.data,
				loading: false,
			};
		case GET_RESOLVE_CONFIG_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case UPDATE_RESOLVE_CONFIG_SUCCESS:
			return {
				...state,
				updateResolveConfigStatus: action.payload,
				loading: false,
			};
		case UPDATE_RESOLVE_CONFIG_FAIL:
			return {
				...state,
				loading: false,
				updateResolveConfigError: action.payload,
			};

				case FETCH_NOTIFICATION_CREDENTIAL_SUCCESS:
			return {
				...state,
				notificationCredential: action.payload,
				loading: false,
				error: null,
			};

		case SAVE_NOTIFICATION_CREDENTIAL_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};
		case UNCONFIGURE_NOTIFICATION_CREDENTIAL_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};

		case FETCH_NOTIFICATION_TEMPLATES_SUCCESS:
			return {
				...state,
				notificationTemplates: action.payload,
				loading: false,
				error: null,
			};

		case BLAST_EMAIL_SUCCESS:
		case BLAST_SMS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
			};

		case FETCH_NOTIFICATION_CREDENTIAL_FAIL:
		case UNCONFIGURE_NOTIFICATION_CREDENTIAL_FAIL:
		case SAVE_NOTIFICATION_CREDENTIAL_FAIL:
		case FETCH_NOTIFICATION_TEMPLATES_FAIL:
		case BLAST_EMAIL_FAIL:
		case BLAST_SMS_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
			
		case LOGOUT_SUCCESS:
			return initialState;

		// user auth error and logout
		case USER_REGISTER_FAIL:
		case USER_VERIFY_FAIL:
		case OPERATOR_LOGIN_FAIL:
		case CHANGE_PASSWORD_FAIL:
		case CREATE_RM_FAIL:
		case CREATE_RAZER_FAIL:
		case USER_DETAILS_FAIL:
		case FETCH_RM_FAIL:
		case FETCH_TOKENKEY_FAIL:
		case UPDATE_TOKENKEY_FAIL:
		case FETCH_DUITNOW_FAIL:
		case FETCH_TOKENKEY_DUITNOW_FAIL:
		case UPDATE_TOKENKEY_DUITNOW_FAIL:
		case FETCH_TOKENKEY_RAZER_FAIL:
		case UPDATE_TOKENKEY_RAZER_FAIL:
		case DISTRIBUTOR_LOGIN_FAIL:
		case CLIENT_LOGIN_FAIL:
		case FETCH_OPERATORS_FAIL:
		case LOYALTY_ADMIN_CHECK_FAIL:
		case STAFF_LOGIN_FAIL:
		case DISTRIBUTOR_VERIFY_FAIL:
		case OPERATOR_VERIFY_FAIL:
		case STAFF_VERIFY_FAIL:
		case FETCH_2FA_FAIL:
		case USER_2FA_VERIFY_FAIL:
		case CREATE_AMPERSANDPAY_FAIL:
		case FETCH_AMPERSANDPAY_FAIL:
		case UPDATE_AMPERSANDPAY_FAIL:
		case CREATE_GHL_FAIL:
		case FETCH_TOKENKEY_GHL_FAIL:
		case FETCH_TOKENKEY_SCAN2PAY_FAIL:
		case UPDATE_TOKENKEY_GHL_FAIL:
		case UPDATE_TOKENKEY_SCAN2PAY_FAIL:
		case UPDATE_TOKENKEY_KIPLE_FAIL:
		case FETCH_TOKENKEY_KIPLE_FAIL:
		case FETCH_KIPLE_FAIL:
		case UPDATE_KIPLE_FAIL:
		case CREATE_KIPLE_FAIL:
		case UPDATE_TOKENKEY_HITPAY_FAIL:
		case FETCH_TOKENKEY_HITPAY_FAIL:
		case FETCH_HITPAY_FAIL:
		case UPDATE_HITPAY_FAIL:
		case CREATE_HITPAY_FAIL:
		case UPDATE_TOKENKEY_PAGBANK_FAIL:
		case FETCH_TOKENKEY_PAGBANK_FAIL:
		case FETCH_PAGBANK_FAIL:
		case UPDATE_PAGBANK_FAIL:
		case CREATE_PAGBANK_FAIL:
		case CREATE_2C2P_FAIL:
		case UPDATE_2C2P_FAIL:
		case FETCH_2C2P_FAIL:
		case UPDATE_TOKENKEY_2C2P_FAIL:
		case FETCH_TOKENKEY_2C2P_FAIL:
		case UPDATE_TOKENKEY_RHB_FAIL:
		case FETCH_TOKENKEY_RHB_FAIL:
		case FETCH_RHB_FAIL:
		case UPDATE_RHB_FAIL:
		case CREATE_RHB_FAIL:
		case UPDATE_CYBERSOURCE_FAIL:
		case FETCH_CYBERSOURCE_FAIL:
		case CREATE_CYBERSOURCE_FAIL:
		case FETCH_TOKENKEY_CYBERSOURCE_FAIL:
		case UPDATE_TOKENKEY_CYBERSOURCE_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		default:
			return state;
	}
};

export const dashboardFilter = () => async (dispatch) => {
	try {
		dispatch({ type: SUMMARY_FILTER_SUCCESS });
	} catch (error) {
		dispatch({ type: SUMMARY_FILTER_FAIL, payload: returnError(error) });
	}
};

export const salesDashboardFilter = () => async (dispatch) => {
	try {
		dispatch({ type: SALES_PERFORMANCE_FILTER_SUCCESS });
	} catch (error) {
		dispatch({ type: SUMMARY_FILTER_FAIL, payload: returnError(error) });
	}
};

export const machineUtilizationFilter = () => async (dispatch) => {
	try {
		dispatch({ type: MACHINE_UTIL_FILTER_SUCCESS });
	} catch (error) {
		dispatch({ type: SUMMARY_FILTER_FAIL, payload: returnError(error) });
	}
};

export const clearFilter = () => async (dispatch) => {
	try {
		dispatch({ type: CLEAR_FILTER_SUCCESS });
		dispatch({ type: 'CLEAR_COIN_REPORT' });
	} catch (error) {
		dispatch({ type: SUMMARY_FILTER_FAIL, payload: returnError(error) });
	}
};

const filterInitialState = {
	summaryDashboardFilter: false,
	salesPerformanceFilter: false,
	machineUtilFilter: false,
};

export const filterReducer = function (state = filterInitialState, action) {
	switch (action.type) {
		// this is for fetching loading time setter
		case SUMMARY_FILTER_SUCCESS:
			return {
				summaryDashboardFilter: true,
				salesPerformanceFilter: false,
				machineUtilFilter: false,
			};

		case SALES_PERFORMANCE_FILTER_SUCCESS:
			return {
				summaryDashboardFilter: false,
				salesPerformanceFilter: true,
				machineUtilFilter: false,
			};
		case MACHINE_UTIL_FILTER_SUCCESS:
			return {
				summaryDashboardFilter: false,
				salesPerformanceFilter: false,
				machineUtilFilter: true,
			};
		case CLEAR_FILTER_SUCCESS:
		case SUMMARY_FILTER_FAIL:
		case SALES_PERFORMANCE_FILTER_FAIL:
		case MACHINE_UTIL_FILTER_FAIL:
			return {
				summaryDashboardFilter: false,
				salesPerformanceFilter: false,
				machineUtilFilter: false,
			};

		default:
			return state;
	}
};
